module.exports = __webpack_public_path__ + "static/typeform-c69caa3c557a8a66241374c0c576b489.svg";